<template>
    <div class="current-pictures">
      <draggable v-model="pictures"  @start="drag=true" @end="drag=false" @change="setSortOrder()" class="row item-pictures">
          <div class="col-md-4 picture text-center" v-for="picture in pictures" v-bind:key="picture.id">
            <img :src="picture.spatie_path" class="img-responsive img-fluid" />
            <span class="badge badge-danger clickable remove" @click="removePicture(picture.id)">remove</span>
          </div>
      </draggable>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import eventHub from '../components/EventHub';

    export default {

        mounted() {
            this.refresh();
        },

        created(){
            eventHub.$on('pictureAdded', (e) => {
                this.refresh();
            });
        },

        components: {
            draggable
        },

        props:['model_id','model_type'],

        data() {
            return {
                pictures: [],
                errors: [],
            }
        },

        computed: {

          sortedPictures(){
              return this.pictures.map(picture =>([picture.id,picture.position]));
          },

        },

        methods: {

            removePicture(id){
                console.log(id);
                this.errors = [];
                axios.post('/admin/deleteMedia', { 
                    id: id,
                 })
                .then(response => {
                    this.message = response.data.message;
                    this.refresh();
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },

            setSortOrder(){
                this.errors = [];
                this.pictures.map((picture,index) => {
                    picture.position = index + 1;
                });

                axios.patch('/admin/sortMedia', { 
                    model_id: this.model_id,
                    model_type: this.model_type,
                    pictures: this.sortedPictures
                })
                .then(response => {
                    this.message = response.data.message;
                })
                .catch(errors => {
                    this.message = response.data.message;
                    this.errors = response.data.errors;
                });
            },

            refresh(){
                let url = '/admin/getMedia/' + this.model_type + '/' + this.model_id;
                axios.get(url)
                .then(response => {
                    this.pictures = response.data.pictures;
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },

        },

    }
</script>